import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"
import { LinkedTabCard } from "src/components/TabCard";

export function MemberBulkEdit() {
  const { t } = useTranslation()
  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        <title>{t('bulk-edit')} | Patent Cockpit</title>
      </Helmet>
      <div className="modern-header-row">
        <h2 className="modern-h2">Bulk Edit</h2>
      </div>
      <div className="main-content bg-pcx-100 pt-0">
        <LinkedTabCard
          links={[
            { to: '.', label: 'From Table' },
            { to: 'linking', label: 'Linking' },
          ]}
        />
      </div>
    </>
  )
}